/* Avanelle — Flash Sale Bar runtime (sections/avanelle-flash-bar.liquid).
   - Countdown in gummy tiles, a rolling window: when it reaches zero it starts again at the
     section's timer length. "shared" = one clock for every shopper, counted from the section's
     start time; "visitor" = counted from the shopper's first visit (localStorage).
   - Claim adds the code to the cart with cart/update.js (keeping codes already on the cart), falls
     back to GET /discount/<code>, then refreshes the cart drawer / cart page. Copy puts the code on
     the clipboard.
   - Sticky strip: mirrors the theme header (assets/page-header.js), which hides while scrolling down
     (.page-header.sticky-enabled without .sticky-show). "down" shows the strip exactly then, in the
     header's place; "up" shows it under the header while scrolling up.
   - Minimize tucks the strip into a small tab. Claimed + minimized persist for the session. */
(function () {
  'use strict';
  if (customElements.get('av-flash-bar')) return;

  function storage(name) {
    return {
      get: function (k) { try { return window[name].getItem(k); } catch (e) { return null; } },
      set: function (k, v) { try { window[name].setItem(k, v); } catch (e) { /* private mode */ } }
    };
  }
  var session = storage('sessionStorage');
  var local = storage('localStorage');
  var MIN_KEY = 'av-fb:min';

  function pad(n) { return (n < 10 ? '0' : '') + n; }

  class AvFlashBar extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      var d = this.dataset;
      this.code = (d.code || '').trim();
      this.cycle = Math.min(24, Math.max(1, Number(d.cycleHours) || 18)) * 3600000;
      this.root = d.root || '/';
      if (this.root.slice(-1) !== '/') this.root += '/';
      this.anchor = this.resolveAnchor(d.timerMode, d.anchor);
      this.claimKey = 'av-fb:claimed:' + this.code.toUpperCase();
      this.digits = Array.prototype.slice.call(this.querySelectorAll('[data-fb-d]'));
      this.secTiles = Array.prototype.slice.call(this.querySelectorAll('[data-fb-sec]'));
      this.srNode = this.querySelector('[data-fb-sr]');
      this.statusNode = this.querySelector('[data-fb-status]');
      this._last = null;

      if (session.get(this.claimKey) === '1') this.classList.add('is-claimed');
      if (session.get(MIN_KEY) === '1') this.classList.add('is-min');

      this.onClick = this.onClick.bind(this);
      this.addEventListener('click', this.onClick);
      this.loop = this.loop.bind(this);
      this.onVisibility = function () { if (!document.hidden) this.loop(); }.bind(this);
      document.addEventListener('visibilitychange', this.onVisibility);
      this.loop();
      this.watchHeader(d.sticky || 'down');
    }

    disconnectedCallback() {
      this._ready = false;
      clearTimeout(this._tick);
      clearTimeout(this._tuck);
      clearTimeout(this._copied);
      clearTimeout(this._refill);
      this.removeEventListener('click', this.onClick);
      document.removeEventListener('visibilitychange', this.onVisibility);
      if (this._observer) this._observer.disconnect();
    }

    resolveAnchor(mode, iso) {
      if (mode === 'visitor') {
        var key = 'av-fb:start:' + this.code.toUpperCase();
        var start = Number(local.get(key));
        if (!start || start > Date.now()) {
          start = Date.now();
          local.set(key, String(start));
        }
        return start;
      }
      var anchor = Date.parse(iso || '');
      return isNaN(anchor) ? Date.UTC(2026, 0, 1) : anchor;
    }

    /* ---- countdown ---- */
    loop() {
      clearTimeout(this._tick);
      var now = Date.now();
      this.render(now);
      if (document.hidden) return; // resumes on visibilitychange
      this._tick = setTimeout(this.loop, 1000 - (now % 1000) + 10);
    }

    render(now) {
      var round = Math.floor((now - this.anchor) / this.cycle) + 1;
      var left = Math.max(0, Math.floor((this.anchor + round * this.cycle - now) / 1000));
      var h = Math.floor(left / 3600);
      var m = Math.floor((left % 3600) / 60);
      var s = left % 60;
      var text = pad(h) + pad(m) + pad(s);
      if (text !== this._text) {
        this._text = text;
        this.digits.forEach(function (el) {
          var ch = text.charAt(Number(el.getAttribute('data-fb-d')));
          if (el.textContent !== ch) el.textContent = ch;
        });
      }
      this.classList.toggle('is-final', left < 3600);
      var odd = s % 2 === 1;
      this.secTiles.forEach(function (el) {
        el.classList.toggle('t1', odd);
        el.classList.toggle('t0', !odd);
      });
      // The clock went UP: a new round started. Replay the gummies "refilling".
      if (this._last !== null && left > this._last + 1) {
        var self = this;
        this.classList.remove('is-refill');
        void this.offsetWidth;
        this.classList.add('is-refill');
        clearTimeout(this._refill);
        this._refill = setTimeout(function () { self.classList.remove('is-refill'); }, 1100);
      }
      this._last = left;
      if (this.srNode && m !== this._srMin) {
        this._srMin = m;
        this.srNode.textContent = (this.dataset.tTime || '').replace('[h]', h).replace('[m]', m);
      }
    }

    /* ---- actions ---- */
    onClick(event) {
      var target = event.target.closest('[data-fb-claim],[data-fb-copy],[data-fb-min],[data-fb-expand]');
      if (!target || !this.contains(target)) return;
      if (target.hasAttribute('data-fb-claim')) this.claim();
      else if (target.hasAttribute('data-fb-copy')) this.copy();
      else if (target.hasAttribute('data-fb-min')) this.minimize(true, true);
      else if (target.hasAttribute('data-fb-expand')) this.minimize(false, true);
    }

    minimize(on, byShopper) {
      var strip = this.querySelector('.av-fb__strip');
      var tab = this.querySelector('[data-fb-expand]');
      var active = document.activeElement;
      var focusMoves = on ? strip && strip.contains(active) : tab === active;
      if (byShopper) this._touched = true;
      this.classList.toggle('is-min', on);
      session.set(MIN_KEY, on ? '1' : '0');
      // The focused control just disappeared: keep keyboard focus on its counterpart.
      if (focusMoves) this.focusFirst(on ? tab : this.querySelector(this.stripRowSelector()));
    }

    stripRowSelector() {
      return this.classList.contains('is-claimed') ? '.av-fb__si--done' : '.av-fb__si--live';
    }

    focusFirst(scope) {
      if (!scope) return;
      var buttons = scope.matches && scope.matches('button') ? [scope] : Array.prototype.slice.call(scope.querySelectorAll('button'));
      for (var i = 0; i < buttons.length; i++) {
        if (buttons[i].offsetParent !== null || getComputedStyle(buttons[i]).position === 'fixed') {
          buttons[i].focus({ preventScroll: true });
          return;
        }
      }
    }

    say(message) {
      var node = this.statusNode;
      if (!node || !message) return;
      node.textContent = '';
      setTimeout(function () { node.textContent = message; }, 40);
    }

    claim() {
      if (this._busy || this.classList.contains('is-claimed') || !this.code) return;
      var self = this;
      var active = document.activeElement;
      var fromStrip = this.querySelector('.av-fb__strip').contains(active);
      var hadFocus = this.contains(active);
      this._busy = true;
      this.classList.add('is-busy');
      this.say(this.dataset.tApplying);
      this.applyCode().then(function (ok) {
        self._busy = false;
        self.classList.remove('is-busy');
        if (!ok) {
          self.say(self.dataset.tError);
          self.classList.add('is-error');
          setTimeout(function () { self.classList.remove('is-error'); }, 600);
          return;
        }
        self.classList.add('is-claimed');
        session.set(self.claimKey, '1');
        self.say(self.dataset.tApplied);
        // The pressed Claim button is now hidden; move focus to the confirmation row's first control.
        if (hadFocus) self.focusFirst(self.querySelector(fromStrip ? '.av-fb__si--done' : '.av-fb__done'));
        // Nothing left to do in the strip: tuck it into the tab unless the shopper takes over.
        self._touched = false;
        clearTimeout(self._tuck);
        self._tuck = setTimeout(function () { if (!self._touched) self.minimize(true, false); }, 2600);
      });
    }

    applyCode() {
      var root = this.root;
      var code = this.code;
      var self = this;
      var json = { credentials: 'same-origin', headers: { Accept: 'application/json' } };
      return fetch(root + 'cart.js', json)
        .then(function (res) { return res.ok ? res.json() : {}; })
        .catch(function () { return {}; })
        .then(function (cart) {
          var codes = (cart.discount_codes || [])
            .map(function (entry) { return entry && entry.code; })
            .filter(function (c) { return c && c.toUpperCase() !== code.toUpperCase(); });
          codes.push(code);
          return fetch(root + 'cart/update.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ discount: codes.join(',') })
          });
        })
        .then(function (res) {
          if (!res.ok) throw new Error('cart/update ' + res.status);
          return res.json();
        })
        .then(function (cart) {
          self.refreshCart(cart);
          return true;
        })
        .catch(function () {
          // Same session-level fallback the scratch popup uses: the code is then applied at checkout.
          return fetch(root + 'discount/' + encodeURIComponent(code), { credentials: 'same-origin' })
            .then(function (res) { return res.ok; })
            .catch(function () { return false; });
        });
    }

    refreshCart(cart) {
      try { document.dispatchEvent(new CustomEvent('cart-drawer:refresh')); } catch (e) { /* no drawer */ }
      try {
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'av-flash-bar', cartData: cart });
        }
      } catch (e) { /* cart page not present */ }
    }

    copy() {
      var self = this;
      var code = this.code;
      var done = function () {
        self.classList.add('is-copied');
        self.say(self.dataset.tCopied);
        clearTimeout(self._copied);
        self._copied = setTimeout(function () { self.classList.remove('is-copied'); }, 2200);
      };
      var fallback = function () {
        try {
          var area = document.createElement('textarea');
          area.value = code;
          area.setAttribute('readonly', '');
          area.style.cssText = 'position:fixed;top:0;left:0;opacity:0;pointer-events:none;';
          document.body.appendChild(area);
          area.select();
          var ok = document.execCommand('copy');
          area.remove();
          if (ok) done();
        } catch (e) { /* nothing else to try */ }
      };
      if (navigator.clipboard && window.isSecureContext) navigator.clipboard.writeText(code).then(done, fallback);
      else fallback();
    }

    /* ---- sticky strip: mirror the header ---- */
    watchHeader(mode) {
      if (mode === 'off') return;
      var header = document.querySelector('.page-header');
      if (!header) return;
      var body = document.body;
      var self = this;
      var sync = function () {
        var enabled = header.classList.contains('sticky-enabled');
        var shown = header.classList.contains('sticky-show');
        var overlay = /(^|\s)(menu-drawer-overlay-on|search-overlay-on|menu-open)(\s|$)/.test(body.className);
        var on = enabled && !overlay && (mode === 'up' ? shown : !shown);
        if (mode === 'up') self.style.setProperty('--av-fb-top', (shown ? header.offsetHeight : 0) + 'px');
        self.classList.toggle('is-stuck', on);
      };
      this._observer = new MutationObserver(sync);
      this._observer.observe(header, { attributes: true, attributeFilter: ['class'] });
      this._observer.observe(body, { attributes: true, attributeFilter: ['class'] });
      sync();
    }
  }

  customElements.define('av-flash-bar', AvFlashBar);
})();
